export default __webpack_public_path__ + "static/media/map-marker.23f9bd51.svg";